import { List, Create, Edit, Card } from "../Components/index.js";

export default [
    {
        path: "/leave/out-pass",
        component: List,
        name: "leave.out.pass",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/out-pass/create",
        component: Create,
        name: "leave.out.pass.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/out-pass/:id/edit",
        component: Edit,
        name: "leave.out.pass.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/leave/out-pass/:id/card",
        component: Card,
        name: "leave.out.pass.card",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/leave/out-pass-print",
        component: () => import("../Components/AllCard.vue"),
        name: "leave.out.pass.print",
        meta: {
            requiresAuth: true,
        },
    },
];
